<template>
	<div class="Box">
		<el-card class="box-card">
			<el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
				<el-row :gutter="35">
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="渠道ID：">
							<el-input v-model="queryParams.admin_id" @change="search" @clear="search" placeholder="请输入渠道ID" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="渠道名称：">
							<el-input v-model="queryParams.admin_name" @change="search" @clear="search" placeholder="请输入渠道名称" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="打款方式">
							<el-select
								v-model="queryParams.pay_method"
                class="w100"
                @change="search" @clear="search"
                clearable
								placeholder="请选择打款方式">
								<el-option label="对公" :value="0"></el-option>
								<el-option label="对私" :value="1"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="开户人">
							<el-input v-model="queryParams.card_holder" @change="search" @clear="search" placeholder="请输入开户人" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="状态">
							<el-select v-model="queryParams.state" @change="search" @clear="search" clearable class="w100" placeholder="请选择平台类型">
								<el-option label="提现中" :value="0"></el-option>
								<el-option label="打款中" :value="1"></el-option>
								<el-option label="已打款" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="申请提现时间">
							<el-date-picker
								style="width: 100%"
								v-model="queryParams.apply_time"
								type="daterange"
								align="right"
								unlink-panels
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								@change="search"
								value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @clear="search"
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="打款时间">
							<el-date-picker
								style="width: 100%"
								v-model="queryParams.finishtime"
								type="daterange"
								align="right"
								unlink-panels
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="search" @clear="search"
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="6" class="mb20">
						<el-button size="medium" type="primary" @click="search">查询</el-button>
						<el-button size="medium" @click="addNoNe">重置</el-button>
					</el-col>
				</el-row>
			</el-form>
			<div class="div_buttom">
				<el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加导出</el-button>
<!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
			</div>
			<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%; text-align: center"
        size="medium"
				@selection-change="handleSelectionChange"
				border
				:header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }"
        v-loading="loading"
			>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column label="渠道商id" >
					<template slot-scope="scope">{{ scope.row.admin_id }}</template>
				</el-table-column>
				<el-table-column label="渠道商" width="100">
					<template slot-scope="scope">{{ scope.row.username }}</template>
				</el-table-column>
				<el-table-column label="提现时间" width="170">
					<template slot-scope="scope">{{ scope.row.created_at }}</template>
				</el-table-column>
				<el-table-column label="划账日期" width="170">
					<template slot-scope="scope">{{ scope.row.finishtime }}</template>
				</el-table-column>
				<el-table-column label="提现金额" width="120">
					<template slot-scope="scope">{{ scope.row.money }}</template>
				</el-table-column>
				<el-table-column label="扣减金额" width="100">
					<template slot-scope="scope">{{ scope.row.deduction_amount }}</template>
				</el-table-column>
				<el-table-column label="实际金额" width="120">
					<template slot-scope="scope">{{ scope.row.actual_amount }}</template>
				</el-table-column>
				<el-table-column label="打款方式" width="120">
					<template slot-scope="scope">{{ scope.row.snapshot.pay_method }}</template>
				</el-table-column>
				<el-table-column label="开户人" width="120">
					<template slot-scope="scope">{{ scope.row.snapshot.card_holder }}</template>
				</el-table-column>
				<el-table-column label="银行" width="160">
					<template slot-scope="scope">{{ scope.row.snapshot.card_bank }}</template>
				</el-table-column>
				<el-table-column label="卡号" width="200">
					<template slot-scope="scope">{{ scope.row.snapshot.card_num }}</template> </el-table-column
				><el-table-column label="渠道商id" width="120">
					<template slot-scope="scope">{{ scope.row.id }}</template>
				</el-table-column>
				<el-table-column label="身份证号" width="170">
					<template slot-scope="scope">{{ scope.row.snapshot.idcard_no }}</template>
				</el-table-column>
				<el-table-column label="抽成比例" width="100">
					<template slot-scope="scope">{{ scope.row.snapshot.benefit }}</template>
				</el-table-column>
				<el-table-column label="类别" width="100">
					<template slot-scope="scope">{{ scope.row.type_text }}</template>
				</el-table-column>
				<el-table-column label="提现状态" width="100">
					<template slot-scope="scope">
						<span>{{ scope.row.state_text }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页组件 -->
			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize" @pagination="getOrderList" />
			<el-dialog :close-on-click-modal="false" title="编辑" :visible.sync="dialogVisible" width="45%" :before-close="handleClose">
				<div>
					<el-form :model="edit" ref="queryForm" :inline="true" label-width="150px" style="display: flex; flex-direction: column; margin-left: 100px">
						<el-form-item label="打款方式：" prop="pay_method">
							<div>{{ this.editList.admin_id }}</div>
						</el-form-item>
						<el-form-item label="申请打款金额：" prop="pay_method">
							<div style="color: #3d7ff7; font-size: 24px">{{ this.editList.money }}</div>
						</el-form-item>
						<el-form-item label="实际打款金额：" prop="card_holder">
							<div style="color: #3d7ff7; font-size: 24px">{{ this.editList.actual_amount }}</div>
						</el-form-item>
						<el-form-item label="申请时间：" prop="card_holder">
							<div>{{ this.editList.created_at }}</div>
						</el-form-item>
						<el-form-item label="申请打款方式：" prop="card_holder">
							<div>{{ this.editList.pay_method_text }}</div>
						</el-form-item>
						<!-- <el-form-item label="付款方信息：" prop="card_holder"> 
                            <div>{{ this.editList.snapshot.card_holder }}</div>
                        </el-form-item> -->
						<el-form-item label="抽成比例：" prop="card_holder">
							<div v-if="this.snapshotList">{{ this.snapshotList.benefit }}</div>
						</el-form-item>
						<el-form-item label="商务负责人：" prop="card_holder">
							<div v-if="this.snapshotList">{{ this.snapshotList.card_holder }}</div>
						</el-form-item>
						<el-form-item label="当前状态：" prop="card_holder">
							<div>{{ this.editList.state_text }}</div>
						</el-form-item>
						<el-form-item label="当前状态：" prop="card_holder" v-if="this.editList.state_text == '提现中'">
							<div>
								<el-radio-group v-model="edit.state">
									<el-radio :label="2">打款中</el-radio>
									<el-radio :label="3">已打款</el-radio>
								</el-radio-group>
							</div>
						</el-form-item>
						<el-form-item label="当前状态：" prop="card_holder" v-if="this.editList.state_text == '打款中'">
							<div>
								<el-radio-group v-model="edit.state">
									<el-radio :label="1">提现中</el-radio>
									<el-radio :label="3">已打款</el-radio>
								</el-radio-group>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" v-if="this.editList.state_text != '已打款'">
					<div style="font-size: 22px; height: 40px; width: 100%; border-top: 1px solid #e8e8e8">
						<el-button size="medium" style="margin-top: 10px; margin-right: 20px" @click="editAd">确定</el-button>
					</div>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
import { OrderApi } from '@/api/Order/index';
import { Session } from '@/utils/storage';
import { processErrors } from "@/utils/errorHandler";

export default {
	name: 'MoneyList',
	components: {},
	data() {
		return {
			SearchFlag: false,
			queryParams: {
				pageNo: 1,
				pageSize: 10,
				admin_id: '',
				admin_name: '',
				pay_method: '',
				card_holder: '',
				state: '',
				apply_time: [],
				finishtime: [],
			},
			edit: {
				// id: this.editList.id,
				state: '',
			},

			dialogVisible: false,
			tableData: [],
			total: 0,
			multipleSelection: [],
			editList: {},
			snapshotList: {},
      loading: false,
		};
	},
	mounted() {
		this.getOrderList();
	},

	methods: {
		editAd() {
			let params = {
				id: this.editList.id,
				state: this.edit.state,
			};
			const api = OrderApi();
			api
				.getOrderedit(params)
				.then((res) => {
					if (res.code == 0) {
						this.$message({
							message: '修改成功',
							type: 'success',
						});
						this.dialogVisible = false;
						this.getOrderList();
					} else {
            processErrors(res);
					}
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		addEdit(row) {
			this.dialogVisible = true;
			const api = OrderApi();
			api
				.getOrdershow(row.id)
				.then((res) => {
					if (res.code == 0) {
						this.editList = res.data;
						this.snapshotList = res.data.snapshot;
					}else{
            processErrors(res);
          }
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		search() {
			this.getOrderList();
		},
		addNoNe() {
			this.queryParams = {
				pageNo: 1,
				pageSize: 10,
				admin_id: '',
				admin_name: '',
				pay_method: '',
				card_holder: '',
				state: '',
				apply_time: [],
				finishtime: [],
			};
      this.getOrderList();
		},

		handleClose(done) {
			done();
			this.$refs['ruleForm'].resetFields();
		},
		addSearch() {
			this.SearchFlag = !this.SearchFlag;
		},
		//添加导出
		addList() {
			const params = { ...this.queryParams };
			const urlParams = new URLSearchParams();

			// 处理其他参数
			Object.keys(params).forEach((key) => {
				if (params[key] && key !== 'pageNo' && key !== 'pageSize' && key !== 'apply_time' && key !== 'finishtime' ) {
					urlParams.append(key, params[key]);
				}
			});
			// 处理 created_at 参数
			if (params.apply_time && Array.isArray(params.apply_time)) {
				params.apply_time.forEach((date) => {
					urlParams.append('apply_time[]', date);
				});
			}
			// 处理 created_at 参数
			if (params.finishtime && Array.isArray(params.finishtime)) {
				params.finishtime.forEach((date) => {
					urlParams.append('finishtime[]', date);
				});
			} // 处理 created_at 参数
      let url = new URL(window.location.href);
      let token = url.searchParams.get('token');
      if(token!==null){
        urlParams.append('token', token)
      } else if (Session.get('token')) {
        urlParams.append('token', Session.get('token'))
      }
			// 获取基础 URL
			const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/withdraw/cwexport';
			// 拼接 URL 参数
			const fullExportUrl = baseExportUrl + '?' + urlParams.toString();
			window.location.href = fullExportUrl;
		},
		getOrderList() {
		  this.loading = true;
			const api = OrderApi();
			api
				.getOrdercwindex(this.queryParams)
				.then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.totalCount;
					}else{
            processErrors(res);
          }
					this.loading = false;
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		handleSelectionChange(val) {
		},
		//修改
		handleUpdate() {},
		//删除
		handleDel() {},
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep el-card__body {
		padding: 0 !important;
	}
	.el-form-item__label {
		width: 100px !important;
	}
}

.el-card__body {
	padding: 0px !important;
}

.btn_left {
	margin-left: 100px;
}

.div_buttom {
	width: 100%;
	display: flex;
	margin-bottom: 20px;
}
</style>
